/**
 * WordPress Dependencies
 */
import { __ } from '@wordpress/i18n';
import { search } from '@wordpress/icons';
import { registerBlockVariation } from '@wordpress/blocks';

import { has } from 'lodash';

registerBlockVariation( 'core/search', {
	icon: search,
	name: 'gutenberghub-query-search',
	title: __( 'Query Search', 'gutenberghub-query-filters' ),
	category: 'ghub-products',
	description: __(
		'Query search allows you specifically search inside query loop. Simply insert it inside the query loop.'
	),
	keywords: [ 'query', 'search', 'loop' ],
	attributes: {
		className: 'ghub-query-search',
		buttonText: 'Search',
		label: 'Search',
	},
	isActive: ( blockAttributes, variationAttributes ) => {
		if ( ! has( blockAttributes, 'className' ) ) {
			return false;
		}

		return (
			blockAttributes.className.indexOf(
				variationAttributes.className
			) !== -1
		);
	},
} );
